import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor } from "../utils";

// Canvas-based text measurement utility
let measureCanvas;
function getTextWidth(text, fontFamily = "Arial", fontSize = 12) {
  if (!measureCanvas) {
    measureCanvas = document.createElement("canvas");
  }
  const context = measureCanvas.getContext("2d");
  context.font = `${fontSize}px ${fontFamily}`;
  const metrics = context.measureText(text);
  return metrics.width;
}

const TOOLTIP_BG_HEIGHT = 18;
const TOOLTIP_BG_PADDING = 6;

class PVITooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const { onClick, fontFamily, fontSize, displayFormat, className, bgFill } =
      this.props;
    const { yAccessor, options, appearance, labelFill } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const pviValue = currentItem && yAccessor(currentItem);

    const pvi =
      (pviValue && pviValue.pvi && displayFormat(pviValue.pvi)) || "n/a";
    const pviMA =
      (pviValue && pviValue.pviMA && displayFormat(pviValue.pviMA)) || "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    // Safety fallbacks for appearance
    const pviColor = appearance?.strokePVI?.color || labelFill || "#8884d8";
    const maColor = appearance?.strokeMA?.color || labelFill || "#FF0000";

    // Calculate text width for background
    const fullText = `PVI (${options.period}): ${pvi} MA: ${pviMA}`;
    const textWidth = getTextWidth(
      fullText,
      fontFamily || "Arial",
      fontSize || 12,
    );
    const bgWidth = textWidth + TOOLTIP_BG_PADDING * 2;

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-pvi"
      >
        {/* Background rectangle */}
        <rect
          x={-TOOLTIP_BG_PADDING}
          y={-5}
          width={bgWidth}
          height={TOOLTIP_BG_HEIGHT}
          fill={bgFill || "#1f2937"}
          rx={6}
          ry={6}
        />
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>PVI (</ToolTipTSpanLabel>
          <tspan fill={pviColor}>{options.period}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>): </ToolTipTSpanLabel>
          <tspan fill={pviColor}>{pvi}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> MA: </ToolTipTSpanLabel>
          <tspan fill={maColor}>{pviMA}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

PVITooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  bgFill: PropTypes.string,

  yAccessor: PropTypes.func.isRequired,
  options: PropTypes.shape({
    period: PropTypes.number.isRequired,
  }).isRequired,
  appearance: PropTypes.shape({
    strokePVI: PropTypes.object.isRequired,
    strokeMA: PropTypes.object.isRequired,
  }).isRequired,
  displayFormat: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
  onClick: PropTypes.func,
};

PVITooltip.defaultProps = {
  origin: [0, 0],
  displayFormat: format(".2f"),
  displayValuesFor: displayValuesFor,
  className: "react-stockcharts-tooltip",
};

export default PVITooltip;
